import {
  type SimpleEventLegacy,
  type DSLValueLegacy,
  SimpleEventTypeLegacy,
} from '@verantos-dev/types-cohorts';

export const transformSimpleEventToDsl = ({
  id,
  name,
  type,
  conceptFilters,
  numericFilters,
  relatedEntityFilters,
  uniquenessFilters,
}: SimpleEventLegacy): DSLValueLegacy => {
  // Determine the type string for the query
  let typeString = '';
  switch (type) {
    case SimpleEventTypeLegacy.CONDITION_OCCURRENCE: {
      typeString = 'CONDITION_OCCURRENCE';
      break;
    }
    case SimpleEventTypeLegacy.DRUG_EXPOSURE: {
      typeString = 'DRUG_EXPOSURE';
      break;
    }
    case SimpleEventTypeLegacy.MEASUREMENT: {
      typeString = 'MEASUREMENT';
      break;
    }
    case SimpleEventTypeLegacy.OBSERVATION: {
      typeString = 'OBSERVATION';
      break;
    }
    case SimpleEventTypeLegacy.PROCEDURE_OCCURRENCE: {
      typeString = 'PROCEDURE_OCCURRENCE';
      break;
    }
    case SimpleEventTypeLegacy.VISIT_OCCURRENCE: {
      typeString = 'VISIT_OCCURRENCE';
      break;
    }
  }

  const simpleEventName = `${typeString}::"${name}"`;

  // Build the query
  const baseQuery = `${simpleEventName} = ${typeString} `;
  const conceptFilterQueries =
    conceptFilters?.length === 0
      ? ''
      : conceptFilters?.map(({ inputFields }) => {
          const conceptFilterQuery = inputFields?.map((inputField) => inputField.value).join(' ');
          return `CF ( ${conceptFilterQuery} )`;
        });
  const numericFilterQueries =
    numericFilters?.length === 0
      ? ''
      : numericFilters?.map(({ inputFields }) => {
          const numericFilterQuery = inputFields?.map((inputField) => inputField.value).join(' ');
          return `NF ( ${numericFilterQuery} )`;
        });
  const relatedEntityFilterQueries =
    relatedEntityFilters?.length === 0
      ? ''
      : relatedEntityFilters?.map(({ inputFields }) => {
          const relatedEntityFilterQuery = inputFields
            ?.map((inputField) => inputField.value)
            .join(' ');
          return `RF ( ${relatedEntityFilterQuery} )`;
        });
  const uniquenessFilterQueries =
    uniquenessFilters?.length === 0
      ? ''
      : uniquenessFilters?.map(({ inputFields }) => {
          const uniquenessFilterQuery = inputFields
            ?.map((inputField) => inputField.value)
            .join(' ');
          return `UF ( ${uniquenessFilterQuery} )`;
        });
  const filterQuery = [
    ...conceptFilterQueries,
    ...numericFilterQueries,
    ...relatedEntityFilterQueries,
    ...uniquenessFilterQueries,
  ].join(', ');

  const closeOffQuery = ' ;\n';
  return {
    id,
    value: baseQuery + '( ' + filterQuery + ' )' + closeOffQuery,
  };
};
